import { getJwt } from "@/features/auth/utils";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { Routes } from "@/features/router";
import { OlkyPassRoutes } from "@/utils/routes";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";

export const LoginPrivateRoutes = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const loggedIn = !!getJwt().token;

  const documentConsentSessionStorage = sessionStorage.getItem("documentConsent");
  const documentConsentSearchParam = searchParams.get("documentConsent");
  const redirectToLvl = searchParams.get("level_to_complete");

  const { leUuid } = useCompanyContext();
  const companyId = sessionStorage.getItem("legalUUid");

  if (!leUuid && companyId) {
    sessionStorage.removeItem("legalUUid");
  } else if (leUuid && leUuid !== companyId) {
    sessionStorage.setItem("legalUUid", leUuid);
  } else if (leUuid && !companyId) {
    sessionStorage.setItem("legalUUid", leUuid);
  }

  const [loginRoute, setLoginRoute] = useState(Routes.flow + "/-/welcome");

  useEffect(() => {
    //tried to access document consent when logged out: must be accessed once logged in
    if (documentConsentSearchParam && !loggedIn) {
      sessionStorage.setItem("documentConsent", documentConsentSearchParam);
    }

    //we access the consent document once logged in
    if (loggedIn && documentConsentSessionStorage) {
      setSearchParams({ documentConsent: documentConsentSessionStorage });
      <Navigate to={OlkyPassRoutes.document_consent} replace />;
      return;
    }

    if (redirectToLvl) {
      if (loggedIn) {
        <Navigate to={OlkyPassRoutes.level} replace />;
        return;
      } else setLoginRoute(`${loginRoute}?level_to_complete=${redirectToLvl}`);
    }
  }, []);
  return loggedIn ? <Outlet /> : <Navigate to={loginRoute} replace />;
};
